export default __webpack_public_path__ + "locales/ru/People.json?hash=a3f5cd0264c6b6000854073e9974ecda";